/* @ngInject */
const excelLoader = (
  wagonExcel,
  persoExcel,
  invoiceExcel,
  scrappingExcel,
  blWagonsExcel,
  blEssieuxExcel,
  destructionExcel,
) => {
  const self = {}

  self.wagon = wagonExcel
  self.perso = persoExcel
  self.invoice = invoiceExcel
  self.scrapping = scrappingExcel
  self.destruction = destructionExcel
  self.blWagons = blWagonsExcel
  self.blEssieux = blEssieuxExcel

  return self
}

export default excelLoader



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/excelLoader.js